var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWheelsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12481_164984)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.41487 10.6736L3.24474 11.3937C4.0243 13.1928 5.70127 14.5152 7.70801 14.7941L7.5188 11.5094L6.41487 10.6725V10.6736ZM6.30026 7.72078L4.64275 4.8988C3.49558 5.9465 2.77441 7.45372 2.77441 9.12636C2.77441 9.47884 2.80793 9.82483 2.86955 10.16L5.83642 9.02689L6.29918 7.72186L6.30026 7.72078ZM8.99898 6.6947L11.1982 4.07707C10.3938 3.64566 9.47472 3.40023 8.49946 3.40023C7.40851 3.40023 6.38784 3.70729 5.51962 4.23925L7.61286 6.69578H8.9979L8.99898 6.6947ZM12.2405 4.79608L10.4554 7.65915L10.8749 8.97932L14.1013 10.3114C14.1823 9.92863 14.2256 9.5329 14.2256 9.12636C14.2256 7.39857 13.4547 5.84811 12.2405 4.79716V4.79608ZM9.92234 9.12528C9.92234 8.34032 9.28551 7.70348 8.50054 7.70348C7.71558 7.70348 7.07874 8.34032 7.07874 9.12528C7.07874 9.91024 7.71558 10.5471 8.50054 10.5471C9.28551 10.5471 9.92234 9.91024 9.92234 9.12528ZM8.49946 0.62582C3.80589 0.62582 0 4.43171 0 9.12528C0 13.8189 3.80589 17.6247 8.49946 17.6247C13.193 17.6247 16.9989 13.8189 16.9989 9.12528C16.9989 4.43171 13.1941 0.62582 8.49946 0.62582ZM8.49946 15.4331C5.02226 15.4331 2.19271 12.6036 2.19271 9.12528C2.19271 5.647 5.02226 2.81745 8.49946 2.81745C11.9767 2.81745 14.8073 5.647 14.8073 9.12528C14.8073 12.6036 11.9777 15.4331 8.49946 15.4331ZM9.26388 11.4586L8.9806 14.8298C11.0825 14.6536 12.8643 13.3388 13.7055 11.505L10.3959 10.6595L9.26496 11.4586H9.26388Z",
    fill: "#343330"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12481_164984"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white",
    transform: "translate(0 0.62582)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheelsIcon);
export default __webpack_public_path__ + "static/media/WheelsIcon.c678d71a.svg";
export { ForwardRef as ReactComponent };